import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  recentSearches: [],
};

const recentSearchSlice = createSlice({
  name: "recentSearch",
  initialState,
  reducers: {
    addSearch: (state, action) => {
      state.recentSearches = Array.isArray(state.recentSearches) ? state.recentSearches : [];
      const payload = action.payload;
      if (typeof payload === 'object' && payload !== null) {
        if (!state.recentSearches.some(item => typeof item === 'object' && item?.id === payload?.id)) {
          state.recentSearches = [payload, ...state.recentSearches].slice(0, 5);
        }
      } else {
        if (!state.recentSearches.includes(payload)) {
          state.recentSearches = [payload, ...state.recentSearches].slice(0, 5);
        }
      }
    },
    removeSearch: (state, action) => {
      state.recentSearches = [...state.recentSearches]?.filter((query) => query !== action.payload);
    },
    clearSearches: (state) => {
      state.recentSearches = [];
    },
  },
});

const {
  actions: { addSearch, removeSearch, clearSearches },
  reducer,
} = recentSearchSlice;

const selectorRecentSearch = (state) => state.recentSearch;

export { addSearch, removeSearch, clearSearches, selectorRecentSearch };

export default reducer;

